import {
    FETCH_ORGANIZATIONS,
    FETCH_TAXONOMY,
    UPDATE_ORGANISATION,
    UPDATE_MOBILE_APP,
    FETCH_PHYSICAL_ORGANIZATIONS,
    UPDATE_PHYSICAL_ORGANISATION,
    FETCH_POIS,
    FETCH_ORGANIZATION_BY_ID
  } from "../constants";

export const fetchOrganizations =() => ({
  type: FETCH_ORGANIZATIONS
});

export const fetchTaxonomy =() => ({
  type: FETCH_TAXONOMY
});

export const updateOrganisation =(data, clientId) => ({
  type: UPDATE_ORGANISATION,
  data,
  clientId
});

export const updateMobileApp =(data, mobileAppId) => ({
  type: UPDATE_MOBILE_APP,
  data,
  mobileAppId
});

export const fetchPhysicalOrganizations =(filters = {}) => ({
  type: FETCH_PHYSICAL_ORGANIZATIONS,
  filters
});

export const updatePhysicalOrganisation =(data, clientId) => ({
  type: UPDATE_PHYSICAL_ORGANISATION,
  data,
  clientId
});

export const fetchPOIs = (organizationId) => ({
  type: FETCH_POIS,
  organizationId
});

export const fetchOrganizationById = (organizationId) => ({
  type: FETCH_ORGANIZATION_BY_ID,
  organizationId
});
